import _ from 'lodash';

// A multi-section home carries up to three serial / HUD label numbers (one per section); show every
// non-blank one in section order, kept as entered (duplicates included). Null when all are blank.
export const formatChattelSectionNumbers = values =>
  values
    .map(value => (_.isString(value) ? value.trim() : value))
    .filter(Boolean)
    .join(', ') || null;
